import React from "react";
import styles from "./Home.module.css";
import Panel from "./Panel";
import DeadlineRow from "./DeadlineRow";
import { toISODate } from "../../../utils/weekDates";

// Milestones due in the next 7 days, overdue first; clicking a row opens its project.
export default function UpcomingDeadlines({ deadlines, onOpenProject }) {
  const today = toISODate(new Date());
  return (
    <Panel title="Upcoming deadlines" count={deadlines.length || null} countTone="neutral" tools={<span className={styles.chip}>Next 7 days</span>}>
      {deadlines.length === 0 ? (
        <div className={styles.empty}>No milestones due in the next 7 days.</div>
      ) : (
        <div className={styles.dlList}>
          {deadlines.map((d) => (
            <DeadlineRow
              key={d.milestone_id}
              date={d.due_date}
              today={today}
              overdue={d.is_overdue}
              title={d.milestone_name}
              sub={[d.client_company, d.project_name].filter(Boolean).join(" · ")}
              ownerName={d.owner_name}
              ownerAvatarUrl={d.owner_avatar_url}
              onClick={() => onOpenProject(d.project_id)}
            />
          ))}
        </div>
      )}
    </Panel>
  );
}
